import { House, Coffee, ForkKnife, Check } from "@phosphor-icons/react";

/**
 * 3 kleine Status-Icons pro Buchung/Zimmer.
 *  - Farbig + „fill", wenn Formular vorliegt (Klick → onOpen(form_type, sub_id))
 *  - Farbig + „regular" + kleines ✓-Badge, wenn manuell erledigt markiert (Klick → onManualToggle → aufheben)
 *  - Grau, wenn offen (Klick → onManualToggle → als manuell erledigt markieren)
 */
const ICONS = [
  { key: "checkin",   Icon: House,     color: "text-emerald-600", bg: "hover:bg-emerald-50", label: "Check-in" },
  { key: "breakfast", Icon: Coffee,    color: "text-amber-600",   bg: "hover:bg-amber-50",   label: "Frühstück" },
  { key: "dinner",    Icon: ForkKnife, color: "text-red-600",     bg: "hover:bg-red-50",     label: "Abendessen" },
];

export default function FormStatusIcons({ status, onOpen, onManualToggle, size = 18, testidPrefix = "form-status" }) {
  return (
    <div className="inline-flex items-center gap-1">
      {ICONS.map(({ key, Icon, color, bg, label }) => {
        const subId = status?.[key];
        const manual = !!status?.[`manual_${key}`];
        const filled = !!subId;
        const done = filled || manual;

        let cls, weight, title;
        if (filled) {
          cls = `${color} ${bg} cursor-pointer`;
          weight = "fill";
          title = `${label}: eingegangen — klicken für Details`;
        } else if (manual) {
          cls = `${color} ${bg} cursor-pointer opacity-80`;
          weight = "regular";
          title = `${label}: manuell erledigt (Gast hat direkt Bescheid gegeben) — klicken zum Aufheben`;
        } else {
          cls = "text-slate-300 hover:bg-slate-100 hover:text-slate-500 cursor-pointer";
          weight = "regular";
          title = `${label}: noch offen — klicken um manuell als erledigt zu markieren`;
        }

        const handle = (e) => {
          e.stopPropagation();
          if (filled) { onOpen?.(key, subId); return; }
          // Grau ODER manuell: Toggle
          const confirmMsg = manual
            ? `${label} für diese Buchung wieder als "offen" setzen? Es kann dann wieder eine automatische Erinnerungsmail an den Gast versendet werden.`
            : `${label} für diese Buchung als manuell erledigt markieren?\n\nSo wird KEINE automatische Erinnerungsmail an den Gast versendet (z.B. weil er dir persönlich, telefonisch oder per WhatsApp Bescheid gegeben hat).`;
          if (!window.confirm(confirmMsg)) return;
          onManualToggle?.(key, !manual);
        };

        return (
          <button
            key={key}
            type="button"
            onClick={handle}
            title={title}
            aria-label={`${label} ${done ? "erledigt" : "offen"}`}
            className={`relative inline-flex items-center justify-center p-1 rounded-md transition ${cls}`}
            data-testid={`${testidPrefix}-${key}`}
          >
            <Icon size={size} weight={weight} />
            {manual && !filled && (
              <span
                className="absolute -top-0.5 -right-0.5 bg-white rounded-full flex items-center justify-center border border-white"
                style={{width: 10, height: 10}}
                title="manuell erledigt"
              >
                <Check size={8} weight="bold" className={color}/>
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
